import { apiRequest } from '../api';
import { TEMPLATE } from '../endPoints';

export const GET_TEMPLATES = (metadataid, pageNo = 0, limit = 30, status) => {
  let params = {
    page: pageNo,
    limit: limit,
    status,
  };
  return apiRequest('get', TEMPLATE.GET_TEMPLATE(metadataid), null, params);
};

export const CREATE_TEMPLATE_SERVICE = (metadataid, data) => {
  return apiRequest('post', TEMPLATE.CREATE_TEMPLATE(metadataid), data);
};

export const GET_TEMPLATE_BY_ID = (metadataid, templateID, templateName) => {
  return apiRequest('get', TEMPLATE.GET_TEMPLATE_BY_ID(metadataid, templateID, templateName));
};

export const GET_WHATSAPP_TEMPLATE_LIBRARY = (metadataid, filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => {
      return value !== undefined && value !== null && value !== '' && value !== 'ALL';
    }),
  );

  return apiRequest('get', TEMPLATE.GET_TEMPLATE_LIBRARY(metadataid), null, params);
};
